// The Grovedock mark (the g of grovedock drawn as a commit on its trunk, the newest landing in
// gold) and the wordmark, set in Schibsted Grotesk Bold.

export function Mark({ size = 24, title }: { size?: number; title?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" role={title ? "img" : undefined} aria-label={title} aria-hidden={title ? undefined : true} className="icon">
      <circle cx="31" cy="28" r="11.5" fill="none" stroke="currentColor" strokeWidth="6.5" />
      <path d="M42.5 20V43Q42.5 56 29 56H24" fill="none" stroke="currentColor" strokeWidth="6.5" strokeLinecap="round" />
      <circle cx="42.5" cy="9" r="5" fill="#F0B429" />
    </svg>
  );
}

/** "grovedock" set in Schibsted Grotesk Bold, `height` tall from the top of its d to the foot of its g. */
export function Wordmark({ height = 15 }: { height?: number }) {
  return (
    <span className="word" style={{ fontSize: height * 1.04 }} aria-hidden="true">
      grovedock
    </span>
  );
}

/** While a screen's code arrives: the same frame index.html paints first, never a blank page. */
export function Loading() {
  return (
    <div className="first" aria-busy="true">
      <div className="first-side">
        <div className="first-brand">
          <Mark size={22} />
          Grovedock
        </div>
      </div>
      <div className="first-main">Loading Grovedock…</div>
    </div>
  );
}
